import { GetApp } from "../../App"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { IUnitDefault } from "../../Types"
import { predefined, PrintShipViewData } from "./Context"
import { PrintShipEnginesViewProps } from "./Params"

// Engines: renders `engineCount` rows, blank placeholders for missing entries.
export function PrintShipEnginesView({ data }: PrintShipEnginesViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData } = PrintShipViewData.resolveShipData(data);

  return (
    <PrintListBlock title={t("engines")}>
      {Array.from(Array(shipData?.engineCount || 0).keys()).map((index) => {
        const engine = PrintShipViewData.engineAt(shipData, index);
        return (
          <div key={engine.id}>
            <BlockRow className="block-row-followed-by-block-row">
              <BlockField label={t("engine#")} className="block-field-45">{engine.number}</BlockField>
              <BlockField label={t("engine_nmea_number")} className="block-field-60">{engine.nmeaNumber}</BlockField>
              <BlockField label={t("engine_short_name")} className="block-field-120">{engine.engineShortName}</BlockField>
              <BlockField label={t("manufacturer")} className="block-field-210">{engine.manufacturer}</BlockField>
              <BlockField label={t("model")} className="block-field-180">{engine.model}</BlockField>
              <BlockField label={t("serial_number")}>{engine.serialNumber}</BlockField>
            </BlockRow>

            <BlockRow className="block-row-last">
              <BlockField label={t("power")} className="block-field-120">{engine.power} {engine.powerUnit || (engine.power ? IUnitDefault.power : "")}</BlockField>
              <BlockField label={t("fuel_type")} className="block-field-120">{PrintShipViewData.predefinedText(t, predefined.fuelType, engine.fuelType, "fuel_")}</BlockField>
              <BlockField label={t("drive_type")} className="block-field-120">{PrintShipViewData.predefinedText(t, predefined.engineDriveType, engine.driveType, "engine_")}</BlockField>
              <BlockField label={t("propeller_type")} className="block-field-120">{engine.propellerType}</BlockField>
            </BlockRow>
          </div>
        );
      })}
    </PrintListBlock>
  );
}
